export default __webpack_public_path__ + "static/media/banner2.a56c78c8.png";